import {
    DialogContent,
    DialogTitle,
    IconButton,
    Switch,
    TextField
} from "@mui/material";
import {Dialog2} from "../../misc/Dialog2";
import {SmoothActionBar} from "../../misc/SmoothActionBar";
import {TaskBoardColumn} from "../../api/Tasks2";
import {useContext, useState} from "react";
import {BoardContext} from "./BoardContextProvider";
import {Close} from "@mui/icons-material";
import {grey} from "@mui/material/colors";
import {useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../api/API";
import {useSyncedRef} from "../../misc/SyncedRef";

export function ViewColumn(props: {
    value: TaskBoardColumn;
    onClose(): void;
}) {
    const ctx = useContext(BoardContext);
    const refreshEverythingRef = useSyncedRef(ctx.refreshEverything);
    const [name, setName] = useState(props.value.title);
    const [isCompleted, setIsCompleted] = useState(props.value.completedColumn);
    const onCloseRef = useSyncedRef(props.onClose);
    const updateCb = useAsyncAction(async input => {
        await api.tasks2.updateBoardColumn(input);
        refreshEverythingRef.current();
        onCloseRef.current();
    }, []);

    const submit = () => {
        updateCb.callback(Object.assign({}, props.value, {
            title: name,
            completedColumn: isCompleted,
        }))
    };

    return (
        <Dialog2 open onClose={() => props.onClose()} onEnterPress={submit}>
            <DialogTitle style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
            }}>
                <div style={{
                    flex: 1,
                }}>
                    <div>Edit Column</div>
                </div>
                <IconButton onClick={props.onClose}>
                    <Close/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />
                <TextField
                    label="Name"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    fullWidth />

                <div style={{height: 16}} />
                <div>
                    Completed
                </div>
                <Switch
                    checked={isCompleted}
                    onChange={e => setIsCompleted(e.target.checked)} />

                <div style={{height: 16}} />
                {Object.keys(props.value.autoAddRule||{}).length > 0 && <>
                    <div>
                        Auto Add Rules
                    </div>
                    <code style={{
                        fontSize: "0.8rem",
                        backgroundColor: grey["100"],
                        padding: 4,
                        borderRadius: 4,
                    }}>
                        {JSON.stringify(props.value.autoAddRule)}
                    </code>
                </>}
            </DialogContent>
            <SmoothActionBar
                loading={updateCb.loading}
                destroyLoading={updateCb.loading}
                error={updateCb.error}
                onSubmit={submit}
                onCancel={props.onClose}
                onDestroy={props.value.id > 0 ? () => {
                    updateCb.callback(Object.assign({}, props.value, {
                        archived: true,
                    }))
                } : undefined}
                destroyName="Archive"
            />
        </Dialog2>
    )
}